export type FilmType = "剧情" | "动画" | "纪录片" | "科幻" | "喜剧";

export interface ShortFilm {
  id: string;
  title: string;
  tagline: string;
  synopsis: string;
  director: string;
  type: FilmType;
  duration: number;
  publishDate: string;
  cover: string;
  views: number;
  rating: number;
  tags: string[];
}

export const filmTypes: FilmType[] = ["剧情", "动画", "纪录片", "科幻", "喜剧"];

export const shortFilms: ShortFilm[] = [
  {
    id: "guitou-12",
    title: "归途",
    tagline: "一辆夜班大巴，载着三个不肯说话的人驶向同一个县城。",
    synopsis:
      "凌晨两点，最后一班县城大巴准时发车。车上只有三个人：带着父亲骨灰的年轻女人，刚被工厂辞退的中年男人，和一个抱着旧吉他的少年。十八个小时的路程里，车窗外的风景从城市变成荒地，又从荒地变成熟悉的稻田。他们谁也没有问对方要去哪里，却在同一处加油站下车，各自走向不同的方向。这是一部关于「回家」这件事究竟意味着什么的短片。",
    director: "林致远",
    type: "剧情",
    duration: 12,
    publishDate: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20bus%20interior%20with%20warm%20amber%20lighting%2C%20rain%20streaked%20windows%2C%20silhouette%20of%20a%20lone%20passenger%20looking%20out%2C%20moody%20teal%20and%20orange%20color%20grading%2C%20shallow%20depth%20of%20field%2C%20film%20still%20aesthetic%2C%20subtle%20grain&width=800&height=450&seq=film-guitou-01&orientation=landscape",
    views: 128400,
    rating: 9.1,
    tags: ["回家", "公路", "夜晚", "人物群像"],
  },
  {
    id: "yunduan-xin",
    title: "云端信",
    tagline: "邮差是一只纸飞机，收信人住在云的背面。",
    synopsis:
      "在一座漂浮于云层之上的小镇，邮差每天的工作是把信件折成纸飞机，投向看不见的地面。直到有一天，一个女孩收到了一封从未被寄出的信，信封上写着她自己的名字。她决定沿着信纸上的折痕，找到那个写信的人。这是一部用温暖手绘风格讲述想念与告别的动画短片。",
    director: "苏念",
    type: "动画",
    duration: 8,
    publishDate: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20animation%20still%20of%20a%20small%20floating%20town%20above%20soft%20pink%20clouds%2C%20a%20child%20releasing%20a%20paper%20airplane%2C%20warm%20pastel%20sky%2C%20whimsical%20storybook%20illustration%20style%2C%20gentle%20light%20rays%2C%20soft%20textured%20brushwork&width=800&height=450&seq=film-yunduan-02&orientation=landscape",
    views: 96500,
    rating: 8.8,
    tags: ["手绘", "治愈", "思念", "奇幻"],
  },
  {
    id: "chengshi-zhiguang",
    title: "城市之光",
    tagline: "凌晨四点的环卫工、早餐摊主与代驾司机，撑起一座城的白天。",
    synopsis:
      "纪录片团队用三个月时间，跟随三位在凌晨四点开始工作的人。环卫工老陈扫完整条街需要两小时四十分钟，早餐摊的刘姐每天要揉三十斤面，代驾小王把最后一个客人送到家时，天刚好亮。他们没有交集，却在同一座城市里交替出现。片子没有旁白，只有街灯熄灭的声音和第一班公交的报站。",
    director: "周远山",
    type: "纪录片",
    duration: 22,
    publishDate: "2026-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20film%20still%20of%20an%20empty%20city%20street%20at%20blue%20hour%20before%20dawn%2C%20a%20street%20sweeper%20in%20orange%20vest%2C%20glowing%20street%20lamps%2C%20wet%20asphalt%20reflections%2C%20realistic%20natural%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=film-chengshi-03&orientation=landscape",
    views: 74200,
    rating: 9.3,
    tags: ["城市", "劳动者", "凌晨", "纪实"],
  },
  {
    id: "niguang-feixing",
    title: "逆光飞行",
    tagline: "太阳熄灭前的最后七十二小时，人类决定把记忆发射出去。",
    synopsis:
      "天文台确认，太阳将在三天后停止发光。各国放弃救援，转而把一座座记忆库送入近地轨道。负责最后一批发射的工程师发现，自己的名字不在任何一份留存的档案里。他决定在倒计时结束前，把自己的一段记忆塞进最后一枚火箭——那是一段没有任何人知道的、关于女儿的记忆。",
    director: "何知白",
    type: "科幻",
    duration: 15,
    publishDate: "2026-10-03",
    cover:
      "https://readdy.ai/api/search-image?query=Sci%20fi%20film%20still%20of%20a%20lone%20engineer%20silhouette%20in%20front%20of%20a%20giant%20rocket%20launch%20tower%20at%20dusk%2C%20deep%20orange%20sky%20fading%20to%20dark%20violet%2C%20industrial%20structures%2C%20atmospheric%20haze%2C%20cinematic%20anamorphic%20composition&width=800&height=450&seq=film-niguang-04&orientation=landscape",
    views: 158900,
    rating: 8.9,
    tags: ["末日", "记忆", "火箭", "父子"],
  },
  {
    id: "jintian-bujiaban",
    title: "今天不加班",
    tagline: "一个把「准时下班」当成起义的普通职员。",
    synopsis:
      "小陈所在的公司有一个不成文的规定：谁先走谁就是不够努力。这天下午六点，他决定准时下班，去参加女儿的亲子运动会。从假装接电话到绕开监控，从电梯口的偶遇到停车场的三次折返，他用尽了毕生的智慧。而真正让他走出大门的，是同事递来的一杯咖啡和一句「帮我也走一个」。",
    director: "毛小满",
    type: "喜剧",
    duration: 6,
    publishDate: "2026-09-28",
    cover:
      "https://readdy.ai/api/search-image?query=Comedic%20cinematic%20still%20of%20an%20office%20worker%20sneaking%20through%20a%20bright%20open%20plan%20office%20holding%20a%20laptop%20bag%2C%20warm%20evening%20sunlight%20through%20large%20windows%2C%20playful%20staging%2C%20clean%20modern%20interior%2C%20slight%20wide%20angle%20distortion&width=800&height=450&seq=film-jiaban-05&orientation=landscape",
    views: 213600,
    rating: 8.5,
    tags: ["职场", "幽默", "家庭", "下班"],
  },
  {
    id: "shenhai-laixin",
    title: "深海来信",
    tagline: "海洋观测站的第十六个月，她收到了自己的声音。",
    synopsis:
      "独自驻守深海观测站的女孩，每天的工作是记录水听器传来的声音。第十六个月，一段熟悉的人声出现在记录里——那是她三年前录给已故母亲的语音留言。她开始反复播放、比对、定位，最终在海底电缆的检修记录里发现了答案。有些信，是海替人保管的。",
    director: "叶静川",
    type: "剧情",
    duration: 18,
    publishDate: "2026-09-24",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20research%20station%20interior%20with%20glowing%20control%20panels%2C%20a%20woman%20wearing%20headphones%20listening%2C%20deep%20teal%20water%20visible%20through%20porthole%2C%20moody%20low%20key%20lighting%2C%20reflective%20surfaces%2C%20film%20grain&width=800&height=450&seq=film-shenhai-06&orientation=landscape",
    views: 88700,
    rating: 9,
    tags: ["海洋", "孤独", "亲情", "声音"],
  },
  {
    id: "zhiyuan",
    title: "纸鸢",
    tagline: "风筝飞走的那天，爷爷终于学会了放手。",
    synopsis:
      "四合院的春天，爷爷每年都要给孙女糊一只风筝。孙女长大了，要去很远的城市读书。这一年，风筝做得比往年都大，线也比往年都长。放飞那天风很大，线在手里绷得发疼——放，还是不放，成了这个春天最难的一道题。全片没有一句对白，只有风声和纸张的响动。",
    director: "苏念",
    type: "动画",
    duration: 5,
    publishDate: "2026-09-20",
    cover:
      "https://readdy.ai/api/search-image?query=Hand%20drawn%20animation%20still%20of%20an%20elderly%20man%20and%20a%20young%20girl%20flying%20a%20paper%20kite%20on%20a%20traditional%20courtyard%20rooftop%2C%20spring%20sky%20with%20soft%20white%20clouds%2C%20delicate%20ink%20wash%20texture%2C%20warm%20sunlight%2C%20nostalgic%20palette&width=800&height=450&seq=film-zhiyuan-07&orientation=landscape",
    views: 67400,
    rating: 9.2,
    tags: ["亲情", "风筝", "成长", "无对白"],
  },
  {
    id: "shan-nabian",
    title: "山那边的课堂",
    tagline: "一所只有七个学生的学校，和一位守了二十年的老师。",
    synopsis:
      "海拔两千米的教学点，七个孩子，一位老师。老师教语文、数学、音乐，也教怎么系鞋带、怎么在雨天走山路。片子里最动人的一段，是他带着孩子们用粉笔在操场上画了一个足球场，然后踢了一场没有边界的比赛。纪录片的镜头很安静，安静到能听见粉笔在黑板上断掉的声音。",
    director: "周远山",
    type: "纪录片",
    duration: 28,
    publishDate: "2026-09-15",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20still%20of%20a%20small%20rural%20classroom%20with%20wooden%20desks%20and%20chalkboard%2C%20mountain%20valley%20visible%20through%20open%20window%2C%20morning%20mist%2C%20natural%20light%20streaming%20in%2C%20children%20seated%2C%20warm%20earth%20tones%2C%20realistic%20photography&width=800&height=450&seq=film-shan-08&orientation=landscape",
    views: 59200,
    rating: 9.4,
    tags: ["乡村教育", "老师", "孩子", "山区"],
  },
  {
    id: "diqici-richu",
    title: "第七次日出",
    tagline: "时间循环里的第七天，他决定不再修正任何事。",
    synopsis:
      "每天醒来都是同一个早晨。前六次，他想尽办法阻止那场事故：改路线、打电话、甚至把自己锁在房间里。第七次，他放弃了一切努力，只是在便利店买了两杯豆浆，坐在天台上看日出。然后他发现，那场事故从来没有发生过——被卡住的，一直是他的记忆。",
    director: "何知白",
    type: "科幻",
    duration: 11,
    publishDate: "2026-09-10",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20young%20man%20sitting%20on%20a%20rooftop%20ledge%20holding%20two%20cups%20of%20soy%20milk%2C%20city%20skyline%20at%20sunrise%2C%20soft%20golden%20haze%2C%20cool%20shadows%2C%20quiet%20contemplative%20mood%2C%20film%20still%20composition&width=800&height=450&seq=film-richu-09&orientation=landscape",
    views: 143200,
    rating: 8.7,
    tags: ["时间循环", "记忆", "日出", "悬疑"],
  },
  {
    id: "xiangqin-jinxing",
    title: "相亲进行时",
    tagline: "一场相亲，两个人，三台手机，四种人生。",
    synopsis:
      "咖啡馆靠窗的位置，第七次相亲。女孩提前十分钟到，男生迟到了三分钟。接下来的四十分钟里，他们各自在手机上和别人聊着天，却对面前的人说着完全不同的故事。直到服务员端错了一杯咖啡，两段精心编排的人生同时露了馅。",
    director: "毛小满",
    type: "喜剧",
    duration: 9,
    publishDate: "2026-09-05",
    cover:
      "https://readdy.ai/api/search-image?query=Comedic%20cinematic%20still%20of%20a%20blind%20date%20at%20a%20window%20seat%20in%20a%20warm%20cafe%2C%20two%20people%20awkwardly%20looking%20at%20phones%2C%20late%20afternoon%20sunlight%2C%20coffee%20cups%20on%20marble%20table%2C%20soft%20bokeh%20background%2C%20natural%20expressions&width=800&height=450&seq=film-xiangqin-10&orientation=landscape",
    views: 176500,
    rating: 8.3,
    tags: ["相亲", "都市", "反讽", "对话"],
  },
  {
    id: "lao-zhaoxiangguan",
    title: "老照相馆",
    tagline: "拆迁前的最后一张合影，来了三十七个陌生人。",
    synopsis:
      "开在巷子口四十年的照相馆要关门了。老板在门口贴了一张纸：免费拍最后一张照片。三天里来了三十七个人——有抱着婴儿的年轻夫妻，有独自前来的老人，有穿着校服的中学生。他们中的很多人从来没有在这里拍过照。老板把每一张底片都洗出来，挂满了整面墙。",
    director: "林致远",
    type: "剧情",
    duration: 14,
    publishDate: "2026-08-30",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20still%20of%20an%20old%20Chinese%20photo%20studio%20interior%20with%20vintage%20cameras%2C%20photo%20prints%20hanging%20on%20walls%2C%20dust%20in%20sunbeams%2C%20warm%20sepia%20tones%2C%20wooden%20furniture%2C%20aged%20textures%2C%20quiet%20melancholic%20mood&width=800&height=450&seq=film-zhaoxiang-11&orientation=landscape",
    views: 104800,
    rating: 9.1,
    tags: ["老城", "照相馆", "拆迁", "陌生人"],
  },
  {
    id: "xingchen-kafei",
    title: "星尘咖啡馆",
    tagline: "这家店只在流星划过的夜晚营业。",
    synopsis:
      "森林深处有一家咖啡馆，只在有流星雨的夜晚开门。店主是一只戴眼镜的猫，菜单上写着「一杯热牛奶，换一个愿望」。这天晚上来了三个客人：一个丢了声音的歌手，一个不敢许愿的小女孩，还有一位已经来过很多次的老先生。天亮之前，他们都得到了想要的东西，只是方式和想象中不太一样。",
    director: "苏念",
    type: "动画",
    duration: 7,
    publishDate: "2026-08-25",
    cover:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20still%20of%20a%20tiny%20cozy%20cafe%20in%20a%20forest%20clearing%20at%20night%2C%20warm%20glowing%20windows%2C%20shooting%20stars%20in%20a%20deep%20indigo%20sky%2C%20wooden%20interior%20with%20lanterns%2C%20hand%20painted%20storybook%20style%2C%20magical%20atmosphere&width=800&height=450&seq=film-xingchen-12&orientation=landscape",
    views: 82100,
    rating: 8.6,
    tags: ["奇幻", "咖啡", "愿望", "治愈"],
  },
  {
    id: "yifenzhong-chuntian",
    title: "一分钟的春天",
    tagline: "整栋写字楼的人，为了一分钟的春天停下手里的活。",
    synopsis:
      "三月的某个下午，写字楼消防演习的警报响了。所有人被迫下楼，站在楼前的空地上。有人不耐烦地看表，有人继续回消息。然后有人抬头，发现楼下的玉兰开花了。手机一个个放下，六百多个人安静地站了一分钟。警报解除，队伍散去，春天继续。",
    director: "毛小满",
    type: "喜剧",
    duration: 4,
    publishDate: "2026-08-20",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20office%20workers%20standing%20in%20a%20plaza%20looking%20up%20at%20a%20blooming%20magnolia%20tree%2C%20spring%20afternoon%20light%2C%20glass%20office%20building%20background%2C%20soft%20white%20petals%20falling%2C%20gentle%20hopeful%20mood%2C%20film%20still&width=800&height=450&seq=film-chuntian-13&orientation=landscape",
    views: 231900,
    rating: 8.4,
    tags: ["春天", "写字楼", "观察", "治愈"],
  },
  {
    id: "wusheng-hechang",
    title: "无声的合唱",
    tagline: "一群听不见的人，组成了一支合唱团。",
    synopsis:
      "这支合唱团的成员全部是听障人士。他们排练时用手语数拍子，用脚底感受地板的震动。指挥是一位失去部分听力的老人，他说：我们唱的不是声音，是节奏。演出那天，台下坐着三百位观众，没有人鼓掌——他们举起双手，用看得见的掌声回应。",
    director: "叶静川",
    type: "纪录片",
    duration: 17,
    publishDate: "2026-08-14",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20still%20of%20a%20choir%20rehearsal%20on%20a%20simple%20stage%2C%20diverse%20group%20using%20sign%20language%2C%20warm%20stage%20spotlight%2C%20dark%20auditorium%20background%2C%20emotional%20expressive%20faces%2C%20natural%20photography%20with%20soft%20contrast&width=800&height=450&seq=film-hechang-14&orientation=landscape",
    views: 76800,
    rating: 9.5,
    tags: ["合唱", "听障", "舞台", "手语"],
  },
];